export default __webpack_public_path__ + "static/lote_1-dbb84ab774bb24a338543ac3141786f6.png";